<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-商会会员-添加
    -->
    <el-dialog
    title="添加商会会员"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    :append-to-body="true"
    
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" label-width="100px">
      <div class="common-form">添加商会会员</div>
      <el-form-item label="商会会员名称" prop="name"  :rules="[{ required: true, message: '请输入商会会员名称' }]">
        <el-input v-model="form.name" 
        placeholder="请输入商会会员名称" class="max-w460"
       
        ></el-input>
      </el-form-item>

        <el-form-item label="简称" prop="short_name"><el-input v-model="form.short_name" 
        placeholder="请输入简称" class="max-w460"></el-input></el-form-item>

   

        <el-form-item label="头像" prop="image_url" :rules="[{ required: true, message: '请设置头像' }]">
        <div>
          <el-button type="primary" @click="openUpload(1)">上传图片</el-button>
          <img :src="form.image_url" class="mt10" width="120px;" v-if="isImg" :isImg="isImg" />
        </div>
      </el-form-item>  

      <el-form-item label="主营业务" prop="business"><el-input v-model="form.business" 
        placeholder="请输入主营业务" class="max-w460"></el-input></el-form-item>


        <el-form-item label="简介" prop="intro">
          <el-input v-model="form.intro" type="textarea"
        placeholder="请输入简介" class="max-w460"></el-input></el-form-item>

        <el-form-item label="联系人" prop="linkman"  :rules="[{ required: true, message: '请输入商会会员名称' }]"><el-input v-model="form.linkman" 
        placeholder="请输入联系人" class="max-w460"
       ></el-input></el-form-item>

        <el-form-item label="联系方式" prop="phone"    :rules="[{ required: true, message: '请输入联系方式' }]"><el-input v-model="form.phone" 
        placeholder="请输入联系方式" class="max-w460"
     ></el-input></el-form-item>

        <el-form-item label="职位" prop="post"><el-input v-model="form.post" 
        placeholder="请输入职位" class="max-w460"
     ></el-input></el-form-item>

     <el-form-item label="所属商会" prop="belong_to"><el-input v-model="form.belong_to" 
        placeholder="请输入所属商会" class="max-w460"
     ></el-input></el-form-item>

         <!-- 关联会员 -->
         <el-form-item label="关联会员" :rules="[{ required: true, message: '请关联会员' }]">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">关联会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img v-if="user_info.avatarUrl" :src="user_info.avatarUrl" width="100" height="100" />
            <div>{{ user_info.nickName }}</div>
          </div>
        </el-row>
        <el-button @click="remove" v-if="form.user_id!=''">移除会员</el-button>
      </el-form-item>

        <el-form-item label="入会时间" prop="time" :rules="[{ required: true, message: '请选择入会时间' }]">
          <el-date-picker
     
                    v-model="form.time"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy-MM-dd" 
                    value-format="yyyy-MM-dd"
                    >
                  </el-date-picker>
        </el-form-item>

    <el-form-item label="所属行业分类：" prop="categorya_id" :rules="[{ required: true, message: '请选择行业分类' }]">
      <el-select v-model="form.categorya_id" >
        <template v-for="cat in category">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>  


    <el-form-item label="详细地址" prop="detail" :rules="[{ required: true, message: '请输入地址' }]">
        <el-input v-model="form.detail" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input v-model="form.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row>
        <el-row class="mb16">
          <el-col :span="24">
            <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
          </el-col>
        </el-row>

      </el-form-item>

      <el-form-item label="排序" prop="sort"  ><el-input v-model="form.sort" 
        placeholder="请输入排序" class="max-w460"
     ></el-input></el-form-item>

      <el-form-item label="审核状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">待审核</el-radio>
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核不通过</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="不通过理由" prop="reject_val" v-if="form.status == 2">
          <el-input v-model="form.reject_val" type="textarea"
        placeholder="请输入不通过理由" class="max-w460"></el-input></el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <GetUser :is_open="open_user" :multi="false" @close="closeDialogFunc"></GetUser>
</el-dialog>
  
</template>

<script>
import Getpoint from '@/components/map/Getpoint.vue';
import CocApi from '@/api/coc.js';
import Upload from '@/components/file/Upload';
import GetUser from '@/components/user/GetUser.vue';
var timestamp=new Date().toLocaleDateString();

export default {
  components: {
    Upload,
    Getpoint,
    GetUser,
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        name: '',
        image_id: '',
        image_url:"",
        short_name:"",
        business:"",
        intro:"",
        linkman:"",
        phone:"",
        post:"",
        belong_to:'',
        time:new Date(timestamp),
        categorya_id:"",
        latitude:"",
        longitude:"",
        detail:"",//详细地址
        coordinate:"",
        user_id:"",
        status:0,
        reject_val:"",
        sort:50
      },
      loading: false,

      dialogVisible:false,
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      category:[],
      user_info:{
        avatarUrl:"",
        nickName:""
      },
      open_user:false,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getCategory();
  },
  props: ["open_add"],
  methods: {
    /*打开弹出层*/
      addClick() {
        this.open_user = true;
      },
       /*关闭获取用户弹窗*/
       closeDialogFunc(e) {
        console.log("e",e)
        if (e.type != 'error') {
          this.user_info = e.params;
          this.form.user_id = e.params.user_id;
        }
        this.open_user = false;
      },
      remove(){
        console.log("移除");
        this.user_info = {
          nickName:"",
          avatarUrl:""
        }
        this.form.user_id = "";
      },

       /*获取经纬度*/
       getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*选择的地址*/
      choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.latitude = e.location.lat;
        this.form.longitude = e.location.lng;
        this.form.detail=e.address;

      },
    /*上传*/
    openUpload(upload_type) {
      this.isupload = true;
    },

    
    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image_url = e[0].file_path;
        this.isImg = true;

      }
      this.isupload = false;
    },

     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    
      /*获取行业分类*/
      getCategory() {
        // console.log(444);return 
        CocApi.getCategory('', true)
          .then(res => {
            this.category = res.data.category;
          })
          .catch(error => {

          });
      },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CocApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/coc/part/add.vue